import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import { Button, Grid, TableContainer } from "@material-ui/core";
import Table from "components/UpdateUi/Table/Table";
import branchStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import FileUpload from "components/FileUpload/FileUpload";
import "react-html5-camera-photo/build/css/index.css";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { APPLICATION_CREATED_MESSAGE } from "assets/properties/properties";
import { removeSpecialCharFileName } from "utils/Utils";
import CameaComponent from "./Camera";
import { parseAndSetFlag } from "utils/Utils";
import { documentCasesNames } from "assets/properties/properties";
import LiveCameraComponent from "./LiveCamera";
import { loanApplicationStatus } from "assets/properties/properties";
import { saveSelfieDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import FileUploadDocument from "components/FileUpload/FileUploadDocument";
import customerLogo from "../../../../../assets/img/customerLogo.png"
import goldLogo from "../../../../../assets/img/goldIcon.png"
import { headerLabel } from "assets/properties/properties";
import { kycDocumentTypes } from "assets/properties/properties";
import DocumentLinks from "./DocumentLinks";
import DigioCameraComponent from "./DigioCamera";
import { thirdPartyIntegrationVendorNames } from "assets/properties/properties";
import { toCamelCase } from "utils/Utils";
import { deviationTableColumns } from "assets/properties/properties";
import { parseDateTimeMDY } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { getDeviationCodes } from "utils/Utils";
import { purposeOfLoanNewList } from "assets/properties/properties";
import ViewImageModal from "../ViewImage/ViewImageModal";
import DocumentPreview from "./DocumentPreview";
import { loanStatusNames } from "assets/properties/properties";
 import * as pdfjsLib from "pdfjs-dist";
const useStyles = makeStyles(branchStyle);
pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.min.mjs";
const DocumentNew = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumber,
  props,
  editable,
  status,
  newCustomer,
  existdocumentLink,
  classes,
  submitted,
  subStatus,
  mobileNumber,
  faceLineNessVendor,
  faceLineNessEnabled,
  featureFlags,
  closeModal,
  showKycFlag,
  logo,
  newLoan,
  existingLoanData
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tableColumns] = useState([
    {id:"level", label: "Level"},
    {id:"name", label: "Name"},
    {id:"role",label:"Role"},
    {id:"hierarchyCode",label:"Designation Code"},
    {id:"approved",label:"Approved"},
  ]);
  const [tableData, setTableData] = useState([]);
  const [deviationTableData, setDeviationTableData] = useState([]);
  const { applicantDetails } = useSelector((state) => state.loanDetail.applicantLoanDetail);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [showCameraImg, setShowCameraImg] = useState(false);
  const [showCameraImgCapture, setShowCameraImgCapture] = useState(false);
  const [showOrnamentCamera, setShowOrnamentCamera] = useState(false);
  const [showOrnamentCameraImg, setShowOrnamentCameraImg] = useState(false);
  const [
    showOrnamentCameraImgCapture,
    setShowOrnamentCameraImgCapture,
  ] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showDeviationTable, setShowDeviationTable] = useState(false);
  const [customerImage, setCustomerImage] = useState("");
  const [customerImageUri, setCustomerImageUri] = useState("");
  const [oldCustomerPhoto, setOldCustomerPhoto]= useState('')
  const [ornamentImageUri, setOrnamentImageUri] = useState("");
  const [ornamentImage, setOrnamentImage] = useState("");
  const [kycDocumentLink, setKycDocumentLink] = useState("");
  const [documentImage1, setDocumentImage1] = useState("");
  const [documentImage1Capture, setDocumentImage1Capture] = useState(false);
  const [documentImage2, setDocumentImage2] = useState("");
  const [documentImage2Capture, setDocumentImage2Capture] = useState(false);
  const [documentImage3, setDocumentImage3] = useState("");
  const [documentImage3Capture, setDocumentImage3Capture] = useState(false);
  const [documentImage4, setDocumentImage4] = useState("");
  const [documentImage4Capture, setDocumentImage4Capture] = useState(false);
  const [documentImage5, setDocumentImage5] = useState("");
  const [documentImage5Capture, setDocumentImage5Capture] = useState(false);
  const [disabledCameraButton, setDisabledCameraButton] = useState(false);
  const [disabledNext, setDisabledNext] = useState(false);
  const [filedata, setFileData] = useState([]);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = featureFlags;
  const cameraImageValidationFlag = parseAndSetFlag(outletData?.cameraImageValidationFlag);
  const enablePreSanctionApproval = parseAndSetFlag(outletData?.enablePreSanctionApproval);
  const enabledAadharMaskedPhoto = parseAndSetFlag(outletData?.enabledAadharMaskedPhoto);
  const { ornamentDetail } = useSelector((state) => state.loanDetail.ornamentDetail);
  const faceMatchConfedenceValue = outletData?.faceMatchConfedenceValue;
    const imageResolutionPercentageFlag = outletData?.imageResolutionPercentageFlag;
    const customerImageDimensions = outletData?.customerImageDimensions;
    const ornamentImageDimensions = outletData?.ornamentImageDimensions;
    const enabledV2InprocessTab = parseAndSetFlag(featureFlags?.enabledV2InprocessTab);
  let documentImage1Component = useRef();
  const [kycDocumentType, setKycDocumentType] = useState("");
  let kycDocumentLinkComponent = useRef();
  let documentImage2Component = useRef();
  let documentImage3Component = useRef();
  let documentImage4Component = useRef();
  let documentImage5Component = useRef();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [imageUrl, setImageUrl]=useState("")
  const [viewImageModal, setViewImageModal]=useState(false)
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [imageTitle, setImageTitle] = useState("");
  const { selfieDetails } = useSelector(
      (state) => state.loanApplication
    );
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  //
  useEffect(() => {
      GetLoanOrnamentDetails();
  }, []);

  const getDocuments = async(currentData) => {
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNumber,
      method: "GET",
      authToken: authToken,
    })
      if(res?.data?.[0]?.documentLinks){
        setDocumentImage1(currentData?.documentPhotoLinks?.[0] ? currentData?.documentPhotoLinks?.[0] : res?.data?.[0]?.documentLinks?.[0] ? res?.data?.[0]?.documentLinks?.[0] : "")
        setDocumentImage2(currentData?.documentPhotoLinks?.[1] ? currentData?.documentPhotoLinks?.[1] :res?.data?.[0]?.documentLinks?.[1] ? res?.data?.[0]?.documentLinks?.[1] : "")
        setDocumentImage3(currentData?.documentPhotoLinks?.[2] ? currentData?.documentPhotoLinks?.[2] :res?.data?.[0]?.documentLinks?.[2] ? res?.data?.[0]?.documentLinks?.[2] : "")
        setDocumentImage4(currentData?.documentPhotoLinks?.[3] ? currentData?.documentPhotoLinks?.[3] :res?.data?.[0]?.documentLinks?.[3] ? res?.data?.[0]?.documentLinks?.[3] : "")
        setDocumentImage5(currentData?.documentPhotoLinks?.[4] ? currentData?.documentPhotoLinks?.[4] :res?.data?.[0]?.documentLinks?.[4] ? res?.data?.[0]?.documentLinks?.[4] : "")
        setKycDocumentLink(currentData?.kycDocumentLink ? currentData?.kycDocumentLink : res?.data?.[0]?.kycDocumentLink )
      }else if (currentData?.documentPhotoLinks?.length > 0 || currentData?.kycDocumentLink) {
        setDocumentImage1(currentData?.documentPhotoLinks?.[0] ? currentData?.documentPhotoLinks?.[0] : "");
        setDocumentImage2(currentData?.documentPhotoLinks?.[1] ? currentData?.documentPhotoLinks?.[1] : "");
        setDocumentImage3(currentData?.documentPhotoLinks?.[2] ? currentData?.documentPhotoLinks?.[2] : "");
        setDocumentImage4(currentData?.documentPhotoLinks?.[3] ? currentData?.documentPhotoLinks?.[3] : "");
        setDocumentImage5(currentData?.documentPhotoLinks?.[4] ? currentData?.documentPhotoLinks?.[4] : "");
        setKycDocumentLink(currentData?.kycDocumentLink ? currentData?.kycDocumentLink : "");
      }
  }
  const GetLoanOrnamentDetails = async () => {
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    })
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      if(existingLoanData?.document?.customerPhotoLinks?.[0]){
         updateData(existingLoanData?.document);
      }else{
        getDocuments()
      }
    }
    else if ((!res?.data?.customerPhotoLinks?.[0] && !res?.data?.ornamentPhotoLinks?.[0]) || res?.data === ''){
      if(existingLoanData?.document?.customerPhotoLinks?.[0]){
         updateData(existingLoanData?.document, res?.data);
      }else{
        getDocuments(res?.data)
      }
    }
     else {
        updateData(res?.data)
      }
  };

  const updateData = (documentData, currentData)=>{
    if(documentData?.customerPhotoLinks !== ""){
        if (documentData?.customerPhotoLinks && documentData?.customerPhotoLinks?.[0]) {
          setCustomerImage(decode(documentData?.customerPhotoLinks[0]));
          if(!newLoan){
            setOldCustomerPhoto(documentData?.customerPhotoLinks[0])
          }
        }
        if (documentData?.ornamentPhotoLinks && documentData?.ornamentPhotoLinks?.[0]) {
          setOrnamentImage(decode(documentData?.ornamentPhotoLinks[0]));
        }
        if(documentData?.kycDocumentLink){
            setKycDocumentLink(currentData?.kycDocumentLink || documentData?.kycDocumentLink)
        }

        if (documentData?.documentPhotoLinks) {
          if (documentData?.documentPhotoLinks?.[0]) {
            setDocumentImage1(decode(documentData?.documentPhotoLinks?.[0]));
          }
          if (documentData?.documentPhotoLinks?.[1]) {
            setDocumentImage2(decode(documentData?.documentPhotoLinks?.[1]));
          }
          if (documentData?.documentPhotoLinks?.[2]) {
            setDocumentImage3(decode(documentData?.documentPhotoLinks?.[2]));
          }
          if (documentData.documentPhotoLinks?.[3]) {
            setDocumentImage4(decode(documentData?.documentPhotoLinks?.[3]));
          }
          if (documentData?.documentPhotoLinks[4]) {
            setDocumentImage5(decode(documentData?.documentPhotoLinks?.[4]));
          }
        }
      }
  }
  const isValidated = () => {
    if(kycDocumentLink === "" && showKycFlag){
      return false;
    }
    if(subStatus==="PRE_PLEDGE"){
      if (customerImage !== ""  && documentImage1 !== "") {
        return true;
      } else {
        return false;
      }
    }
    else {
      if (customerImage !== "" &&  ornamentImage !== "" && documentImage1 !== "") {
        return true;
      } else {
        return false;
      }
    }
  };

const pdfToJpg = async (pdfBlob) => {
  if (!(pdfBlob instanceof Blob)) {
    throw new Error(
      `Expected Blob, received: ${typeof pdfBlob}`
    );
  }
  const arrayBuffer = await pdfBlob.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({
    data: arrayBuffer,
  }).promise;
  if (pdf.numPages === 0) {
    throw new Error("PDF has no pages");
  }

  // First page
  const page = await pdf.getPage(1);
  const scale = 2;
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Could not create canvas context");
  }

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({
    canvasContext: context,
    viewport,
  }).promise;

  const jpgBlob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(
            new Error("Failed to convert PDF page to JPG")
          );
        }
      },
      "image/jpeg",
      0.9
    );
  });
  return new File(
    [jpgBlob],
    "kycDocument.jpg",
    {
      type: "image/jpeg",
    }
  );
};
 const checkFaceMatch = async () => {
  try {
    const oldSource = newLoan ? kycDocumentLink : oldCustomerPhoto;
    const oldFileName = newLoan ? "kycDocument.jpeg" : "oldCustomerPhoto.jpeg";
    const oldResponse = await fetch(`/proxy/s2?url=${encodeURIComponent(oldSource)}`);
    const oldBlob = await oldResponse.blob();
    const oldContentType = (oldBlob.type || oldResponse.headers.get("content-type") || "").split(";")[0].toLowerCase();
    let oldFaceMatchFile = oldBlob;
    console.log(oldContentType,'oldContentType')
    if (oldContentType === "application/pdf") {
      oldFaceMatchFile = await pdfToJpg(oldBlob);
    } else {
      oldFaceMatchFile = new File([oldBlob], oldFileName, {
        type: oldContentType || "image/jpeg",
      });
    }
    const newResponse = await fetch(
      `/proxy/s3?url=${encodeURIComponent(customerImage)}`
    );
    const newBlob = await newResponse.blob();
    const newContentType = (newBlob.type || newResponse.headers.get("content-type") || "").split(";")[0].toLowerCase();

    let newFaceMatchFile = newBlob;
    // if (newContentType.startsWith("image/")) {
      newFaceMatchFile = new File([newBlob], "customerPhoto.jpeg", {
        type: newContentType || "image/jpeg",
      });
    // } else {
    //   throw new Error(`Unsupported customer photo type: ${newContentType}`);
    // }
    const formData = new FormData();
    formData.append("file1", newFaceMatchFile, "customerPhoto.jpeg");
    formData.append("file2", oldFaceMatchFile, oldFileName);

    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.CHECK_FACE_MATCH,
      method: "POST",
      authToken: authToken,
      data: formData,
    });

    setCallInProgress(false);

      if (result?.data?.error_code || result?.data?.error) {
        toastUpdate("Error", result?.data?.user_description || result?.data?.error, true);
        return false;
      }

      const matched =
        result?.data?.matchResult !== "failed" &&
        result?.data?.matchResult !== "not_matched" &&
        Number(result?.data?.confidence) >= Number(faceMatchConfedenceValue);

    if (matched) {
      toastUpdate(
        "Success",
        "Photo Matched Successfully",
        true
      );
      return true;
    }

      toastUpdate("Warning", "Photo Did Not Match", true);
      return false;

    } catch (err) {
      setCallInProgress(false);
      toastUpdate("Error", "Face match failed", true);
      return false;
    }
  };

  const handleDocumentSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isValidated()) {
    if (showKycFlag) {
      const faceOk = await checkFaceMatch();
      if (!faceOk) return;
    }
    documentsubmit(event);
    }
      else {
        let errors = [];
        if(kycDocumentLink === "" && showKycFlag){
          errors.push("KYC Document");
        }
        if (subStatus === "PRE_PLEDGE") {
          if (!customerImage) errors.push("customer photo");
          if (!documentImage1) errors.push("document photo");
        } else {
          if (!customerImage) errors.push("customer photo");
          if (!documentImage1) errors.push("document photo");
          if (!ornamentImage) errors.push("ornament photo");
        }
      
        if (errors.length > 0) {
          toastUpdate("Error", `Please upload the ${errors.join(", ")}`, true);
        }
        return;
    }
  };
  const documentsubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const documentLinks = [
      documentImage1?.trim(),
      documentImage2?.trim(),
      documentImage3?.trim(),
      documentImage4?.trim(),
      documentImage5?.trim(),
    ].filter(image => image);
      setCallInProgress(true);
      //ADMIN_DOCUMENT_UPDATELINKS
      const res = await apiHandler({
        url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          customerPhotoLinks: [customerImage?.trim()],
          ornamentPhotoLinks: [ornamentImage?.trim()],
          documentPhotoLinks: documentLinks,
          kycDocumentLink:kycDocumentLink?.trim(),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
          handleCreateProfile();
    }
  };
  const handleCreateProfile = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.ADMIN_CREATE_PROFILE_NEW + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    // setCustomerId(res?.data?.customerId);
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error",res?.data?.user_description, true);
    } else {
      //setCustomerId(res?.data?.customerId);
      handleLoanApplicant(res?.data?.customerId,res?.data?.newCustomer);
    }
  };
  //
  const handleAadharMasked = async (file, type) => {
    if(kycDocumentType === loanStatusNames?.aadhaar && enabledAadharMaskedPhoto){
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name)
    formData.append("front", file, fileName);
    formData.append("caseId", loanApplicationId);
    setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.AADHAR_PHOTO_MASKED,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false);
    if (path?.data?.error_code || path?.data?.error) {
      toastUpdate("Error", path?.data?.user_description || path?.data?.error, true);
      return;
    }else{
      setKycDocumentLink(path?.data?.documents?.[0]?.maskedDocumentUrl);
    }}else{
      UploadFile(file, type);
    }
  }
  const UploadFile = async (file, type) => {
    if (!file) {
    switch (type) {
      case documentCasesNames?.kyc:
        setKycDocumentLink(null);
        break;
      case documentCasesNames?.customer:
        setCustomerImage(null);
        break;
      case documentCasesNames?.ornament:
      setOrnamentImage(null);
      break;
      case documentCasesNames?.case1:
        setDocumentImage1(null);
        setDocumentImage1Capture(false);
        break;
      case documentCasesNames?.case2:
        setDocumentImage2(null);
        setDocumentImage2Capture(false);
        break;
      case documentCasesNames?.case3:
        setDocumentImage3(null);
        setDocumentImage3Capture(false);
        break;
      case documentCasesNames?.case4:
        setDocumentImage4(null);
        setDocumentImage4Capture(false);
        break;
      case documentCasesNames?.case5:
        setDocumentImage5(null);
        setDocumentImage5Capture(false);
        break;
      default:
        break;
    }
    return;
  }
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name)
        formData.append("file", file, fileName);
    setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false)
    const uploadedPath = path.data;
    switch (type) {
      case documentCasesNames?.customer:
        setCustomerImage(uploadedPath.name);
        break;
      case "ornament":
        setOrnamentImage(uploadedPath.name);
        break;
      case "KYC":
        setKycDocumentLink(uploadedPath.name);
        break;
      case documentCasesNames?.case1:
        setDocumentImage1(uploadedPath.name);
        setDocumentImage1Capture(true);
        break;
      case documentCasesNames?.case2:
        setDocumentImage2(uploadedPath.name);
        setDocumentImage2Capture(true);
        break;
      case documentCasesNames?.case3:
        setDocumentImage3(uploadedPath.name);
        setDocumentImage3Capture(true);
        break;
      case documentCasesNames?.case4:
        setDocumentImage4(uploadedPath.name);
        setDocumentImage4Capture(true);
        break;
      case documentCasesNames?.case5:
        setDocumentImage5(uploadedPath.name);
        setDocumentImage5Capture(true);
        break;
      default:
        break;
    }
  };
  useEffect(()=>{
    if(status === "SUBMITTED"){
    getApprovalHistoryData();
    getDeviationHistoryData();
    }
  },[status])

  const getApprovalHistoryData = async (type) => {
      const result = await apiHandler({
        url: endpoint.COLLATERAL_EVALUATION_STATUS + loanApplicationId,
        method: "GET",
        authToken: authToken,
      });
  
      if (result?.data?.error_code || !result?.data || Object.keys(result?.data).length === 0) {
        if(type ==="closeModal"){
           handleCloseModal('save');
        }
      return;
    }
  
      const result1 = await apiHandler({
        url: endpoint.MASTER_HIERARCHY_FIND_BY_CODE,
        method: "GET",
        authToken: authToken,
      });
  
      const reportData = result?.data;
      const hierarchyData = result1?.data;
      let labelMap = {};
  
      for (let key in reportData) {
  // eslint-disable-next-line no-prototype-builtins
        if (reportData.hasOwnProperty(key)) {
          let levelData = reportData[key];
          let dataArray = levelData.approvalUsers || [];
  
          if (dataArray.length === 0) {
            labelMap[key] = {
              level: levelData?.level || key,
              name: "N/A",
              role: "N/A",
              hierarchyCode: "N/A",
              approved: levelData?.approved ? "approved" : "pending"
            };
          } 
          else {
            dataArray.forEach((decisionDetails) => {
              let label = decisionDetails?.level || key;
              const hierarchyName = hierarchyData.find(item => item.code === decisionDetails?.hierarchyCode)?.name || 'Unknown';
  
              if (!labelMap[label]) {
                labelMap[label] = {
                  level: levelData?.level || key,
                  name: decisionDetails?.name,
                  role: decisionDetails?.role,
                  hierarchyCode: decisionDetails?.designation,
                  approved: levelData?.approved ? "approved" : "pending"
                };
              } else {
                labelMap[label].name += `, ${decisionDetails?.name}`;
                labelMap[label].role += `, ${decisionDetails?.role}`;
              }
            });
          }
        }
      }
  
      let tableData = Object.values(labelMap);
      setShowTable(true);
      setTableData(tableData);
  };
  const getDeviationHistoryData = async () => {
    const result = await apiHandler({
      url: endpoint.DEVIATION_HISTORY + loanApplicationId,
      method: "GET",
      authToken,
    });

    if (!result?.data || result.data.length === 0) return;

    const reportData = result.data;
    let tableRows = [];
    reportData.forEach((record) => {
      const status = record.status;
      const approvalUsers =  record?.userBasicDetailResponse?.adminUserMap || {};
      const approvedByEmail = record.approvedBy;
      const deviationCodes = getDeviationCodes(record.deviationJson);
      let approvedStatus =
        status === "REALIZED"
          ? "Approved"
          : status === "REJECTED"
          ? "Rejected"
          : status === "SENDBACK"
          ? "Send Back"
          : "Pending";
      const allUsers = Object.values(approvalUsers).flat();
      if (status === "ENTERED") {
        Object.keys(approvalUsers).forEach((designation) => {
          const users = approvalUsers[designation] || [];
          const names = users.map((u) => u.name).join(", ");

          tableRows.push({
            name: names || "N/A",
            hierarchyCode: designation,
            approved: "Pending",
            date: "N/A",
            remarks: "N/A",
            deviationCode: deviationCodes,
          });
        });
      }
      else {
        const approvedUser = allUsers.find(
          (u) => u.username === approvedByEmail || u.email === approvedByEmail
        );

        tableRows.push({
          name: approvedUser?.name || approvedByEmail || "N/A",
          hierarchyCode: approvedUser?.designation || "N/A",
          date: parseDateTimeMDY(record.reviewedDate) || "N/A",
          remarks: record.remarks || "N/A",
          deviationCode: deviationCodes,
          approved: approvedStatus,
        });
      }
    });

    setDeviationTableData(tableRows);
    setShowDeviationTable(true);
  };

  const handleLoanApplicant = async (customerIds, isNewCustomer) => {
    setCallInProgress(true)
    //ADMIN_LOANACCOUNTNUMBER;
    const res = await apiHandler({
      url: endpoint.ADMIN_LOANACCOUNTNUMBER ,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        customerId: customerIds,
        newCustomer: isNewCustomer,
      },
    });
    setCallInProgress(false)
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      if(enablePreSanctionApproval){
        const status = await apiHandler({
          url: endpoint.SANCTION_STATUS_UPDATE,
          method: "PUT",
          authToken: authToken,
          data: {
            loanApplicationId: loanApplicationId,
            status: "PRE_SANCTIONED",
          },
        });
        if(status?.data?.error_code){
          toastUpdate("Error", res?.data?.user_description, true);
        }
        else{
          toastUpdate("Success",APPLICATION_CREATED_MESSAGE, true);
          handleCloseModal('save');
        }
      }else{ 
        const status = await apiHandler({
          url: endpoint.SANCTION_UPDATED_CHANGE_STATUS + loanApplicationId,
          method: "PUT",
          authToken: authToken,
        });
        if(status?.data?.error_code){
          toastUpdate("Error", res?.data?.user_description, true);
        }
        else{
          toastUpdate("Success",APPLICATION_CREATED_MESSAGE, true);
          getApprovalHistoryData("closeModal");
        }
      }
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    //props.history.go(-1);
     dispatch(saveSelfieDetails(""))
    setBack();
  };

  const fileInput = useRef();
  const onClickImportData = () => {
    fileInput.current.click();
  };
  const setFileUploaded = (dataParse) => {
    let bulkData = [];
    dataParse.forEach((dataRow, index) => {
      if (index !== 0) {
        if (dataRow[0]) bulkData.push(dataRow[0]);
      }
    });
    const uploadBulkData = async () => {
      let newPath = filedata;
      let name = filedata.path.substring(
        filedata.path.lastIndexOf("/") + 1,
        filedata.path.length
      );
      setCallInProgress(true)
      //ADMIN_FILE_UPLOADFILE
      const path = await apiHandler({
        url: endpoint.ADMIN_FILE_UPLOADFILE,
        method: "POST",
        authToken: authToken,
        data: {
          uri: newPath,
          name: name,
          type: filedata.mime,
        },
      });
      setCallInProgress(false)

      return path;
    };
    uploadBulkData();
  };
  const handleTakePhoto = async (dataUri, type) => {
    // Do stuff with the photo...
    // console.log("takePhoto", dataUri);
    setCallInProgress(true);
    switch (type) {
      case documentCasesNames?.customer:
        setCustomerImageUri(dataUri);
        setShowFileUpload(false);
        setShowCamera(false);
        setShowCameraImg(true);
        break;
      case "ORNAMENT":
        setOrnamentImageUri(dataUri);
        setShowOrnamentCamera(false);
        setShowOrnamentCameraImg(true);
        break;
      default:
        setShowFileUpload(false);
        setShowCamera(false);
        setShowCameraImg(false);
        setShowOrnamentCamera(false);
        setShowOrnamentCameraImg(false);
    }
    //const formData = new FormData();
    const blob = await fetch(dataUri).then((res) => res.blob());
    UploadCameraFile(blob, type);
  };
  const UploadCameraFile = async (blob, type) => {
    const formData = new FormData();
    formData.append("file", blob, type);
    if(blob?.size > 100){
    setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false)
    if(path?.data?.error || path?.data?.error_code){
      toastUpdate("Error",path?.data?.error || path?.data?.user_description,true);
    }else{
      console.log(path.data,"selfieDetails11111111111")
    const uploadedPath = path.data;
    switch (type) {
      case documentCasesNames?.customer:
        setCustomerImage(uploadedPath?.name);
        break;
      case "ORNAMENT":
        setOrnamentImage(uploadedPath?.name);
        break;
      default:
        break;
    }
  }
    setCallInProgress(false);
  }else{
    setCallInProgress(false);
    toastUpdate("Error", "Photo size is 0 byte. Kindly reclick the photo", true)
  }
  };
  const handleCameraError = (error) => {
    console.log("handleCameraError", error);
  };
  const handleCameraStart = (stream) => {
    console.log("handleCameraStart");
  };
  const handleCameraStop = () => {
    console.log("handleCameraStop");
  };
  //
  const handlenext = () => {
    setNext();
  };
  const handleClose=()=>{
      navigate("/loanservice/submitted", { state: { from: "" } });
  }
  const decode = (str) => {
    // add another escaped slash if the string ends with an odd
    // number of escaped slashes which will crash JSON.parse
    let parsedStr = str.replace(/[{}]/g, '');

    // escape unescaped double quotes to prevent error with
    // added double quotes in json string
    parsedStr = parsedStr.replace(/(^|[^\\])((\\\\)*")/g, "$1\\$2");

    parsedStr = JSON.parse(`"${parsedStr}"`);
    parsedStr = parsedStr.replace(/^"|"$/g, '');
    return parsedStr;
  };
  
   useEffect(() => {
    const processSelfie = async () => {
      console.log(selfieDetails,"selfieDetails")
      if (selfieDetails?.sourceId && selfieDetails?.imageUrl && selfieDetails?.isLive) {
        try {
          const blob = await fetch(selfieDetails.imageUrl).then((res) => res.blob());
          UploadCameraFile(blob, documentCasesNames?.customer);
        } catch (error) {
          console.error("Error fetching selfie image:", error);
        }
      }else {
        if(selfieDetails?.isLive === false){
          toastUpdate("Error","Cusotmer Photo is not proper please re-take the photo",true);
        }
      }
    };
    if(selfieDetails?.imageUrl){
      processSelfie();
    }
  }, [selfieDetails?.sourceId, selfieDetails?.imageUrl]);
  const fileUploadComponent = (imageTitle, imagePath, refrence) =>{
    return(
                <FileUploadDocument
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: brandTheme.button2Color,
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                      "application/pdf",
                    ]}
                    sendFile={(file) => UploadFile(file, imageTitle)}
                    removeFile={() => proceedApplication(imageTitle)} 
                    ref={refrence}
                    previewImage={imagePath}
                  /> 
    )
  }
  const proceedApplication = (title) => {
    setConfirmationModalHeader("Document");
    setConfirmationModalMsg(
      "Are you sure you want to this document"
    );
    setConfirmationModal(true);
    setImageTitle(title)
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete loanMarking
    UploadFile(null,imageTitle);
  };
  const handleCloseModal = (type) => {
    if (type) {
      toastUpdate("Success", "Loan Create successfully", true);
    }
    if(enabledV2InprocessTab){
      navigate("/loanservice/inProcess/V2", { state: { from: '' } }); 
    }else{
      navigate("/loanservice/inProcess", { state: { from: '' } }); 
    }
  }
  return (
    <div>
      <GridContainer style={{ flexDirection: "row" }}>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "start" }}>
           <SubHeader
                           label={headerLabel?.document}
                           subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                           onlyLabel/>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {editable === true && (
            <GridItem xs={12} sm={12} md={12} lg={12}>
              
              <Grid container spacing={3}>
                    
                {/* Customer Camera */}
                <Grid item xs={12} md={6}>
                  <Grid container justifyContent="center">
                    {faceLineNessEnabled ? (
                      faceLineNessVendor === thirdPartyIntegrationVendorNames?.digio ? (
                        <DigioCameraComponent
                          setDisabledSubmit={setDisabledNext}
                          type={documentCasesNames?.customer}
                          UploadCameraFile={UploadCameraFile}
                          customerImage={customerImage}
                          classes={classes}
                          loanApplicationId={loanApplicationId}
                          loanApplicationNumber={loanApplicationNumber}
                          faceLineNessVendor={faceLineNessVendor}
                          imageIcon={customerLogo}
                          image={customerImage}
                          featureFlags={featureFlags}
                          mobileNumber={mobileNumber}
                          logo={logo}
                          customerName={
                            toCamelCase(applicantDetails?.nameOnAdhaar) ||
                            toCamelCase(applicantDetails?.nameOnPanCard)
                          }
                        />
                      ) : (
                        <LiveCameraComponent
                          customerImage={customerImage}
                          classes={classes}
                          loanApplicationId={loanApplicationId}
                          loanApplicationNumber={loanApplicationNumber}
                          faceLineNessVendor={faceLineNessVendor}
                          imageIcon={customerLogo}
                          image={customerImage}
                          mobileNumber={mobileNumber}
                        />
                      )
                    ) : (
                      <CameaComponent
                        classes={classes}
                        UploadCameraFile={UploadCameraFile}
                        type={documentCasesNames?.customer}
                        imageResolutionPercentageFlag={imageResolutionPercentageFlag}
                        cameraImageValidationFlag={cameraImageValidationFlag}
                        imageIcon={customerLogo}
                        image={customerImage}
                        imageDimensions={customerImageDimensions}
                        disabledCameraButton={disabledCameraButton}
                        setDisabledCameraButton={setDisabledCameraButton}
                      />
                    )}
                  </Grid>
                </Grid>
                  
                {/* Ornament Camera */}
                <Grid item xs={12} md={6}>
                  <Grid container justifyContent="center">
                    <CameaComponent
                      classes={classes}
                      UploadCameraFile={UploadCameraFile}
                      type="ORNAMENT"
                      imageResolutionPercentageFlag={imageResolutionPercentageFlag}
                      cameraImageValidationFlag={cameraImageValidationFlag}
                      imageIcon={goldLogo}
                      image={ornamentImage}
                      imageDimensions={ornamentImageDimensions}
                      disabledCameraButton={disabledCameraButton}
                      setDisabledCameraButton={setDisabledCameraButton}
                    />
                  </Grid>
                </Grid>
              </Grid>
                  
              {/* Documents Section */}
              <Grid item xs={12}>
                <DocumentLinks
                  title="Documents"
                  kycDocumentType={kycDocumentType}
                  kycDocumentTypes={kycDocumentTypes}
                  onKycDocumentChange={setKycDocumentType}
                  kycPreviewImage={{
                    face: kycDocumentLink,
                  }}
                  kycUploadRef={{
                    face: kycDocumentLinkComponent,
                  }}
                  onKycUpload={(file, type) => handleAadharMasked(file, type)}
                  onDeleteUpload={(type) => proceedApplication(type)}
                  documentCasesNames={documentCasesNames}
                  documentImages={[
                    documentImage1,
                    documentImage2,
                    documentImage3,
                    documentImage4,
                    documentImage5,
                  ]}
                  documentRefs={[
                    documentImage1Component,
                    documentImage2Component,
                    documentImage3Component,
                    documentImage4Component,
                    documentImage5Component,
                  ]}
                  fileUploadComponent={fileUploadComponent}
                  brandTheme={{
                    buttonColor: "blue",
                    button2Color: "red",
                  }}
                  applicantDetails={applicantDetails}
                  ornamentDetail={ornamentDetail}
                  classes={classes}
                  featureFlags={featureFlags}
                />
              </Grid>
                
            </GridItem>
          )}
          {editable === false && (
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {/* CUSTOMER + ORNAMENT SAME ROW */}
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={6} md={6} style={{ textAlign: "center" }}>
                  {showCameraImg && (
                    <img
                      src={customerImageUri}
                      alt="customerImageUri"
                      style={{
                        width: "100%",
                        maxWidth: "300px",
                        height: "auto",
                      }}
                    />
                  )}
          
                  {customerImage !== "" && (
                    <img
                      src={customerImage}
                      alt="customerImage"
                      style={{
                        width: "100%",
                        maxWidth: "300px",
                        height: "auto",
                      }}
                    />
                  )}
                </Grid>
                
                <Grid item xs={12} sm={6} md={6} style={{ textAlign: "center" }}>
                  {showOrnamentCameraImg && (
                    <img
                      src={ornamentImageUri}
                      alt="ornamentImageUri"
                      style={{
                        width: "100%",
                        maxWidth: "300px",
                        height: "auto",
                      }}
                    />
                  )}
          
                  {ornamentImage !== "" && (
                    <img
                      src={ornamentImage}
                      alt="ornamentImage"
                      style={{
                        width: "100%",
                        maxWidth: "300px",
                        height: "auto",
                      }}
                    />
                  )}
                </Grid>
              </Grid>
                
              {/* DOCUMENT PHOTO TITLE */}
              <p
                style={{
                  fontSize: 22,
                  fontWeight: "bold",
                  textAlign: "left",
                  paddingLeft: "9%",
                }}
              >
                Document Photo
              </p>
              
              {/* DOCUMENT IMAGES */}
              <GridContainer
                style={{
                  justifyContent: "center",
                  textAlign: "center",
                  flexWrap: "wrap",
                  gap: "15px",
                }}
              >
                {[

                kycDocumentLink,
                documentImage1,
                documentImage2,
                documentImage3,
                documentImage4,
                documentImage5,
              ]
                .filter(Boolean)
                .map((file, index) => {
                  const isPdf = file?.toLowerCase().includes(".pdf");
                  return (
                    <Grid key={index}>
                    <DocumentPreview
                      file={file}
                      index={index}
                      isPdf={isPdf}
                      setImageUrl={setImageUrl}
                      classes={classes}
                      setViewImageModal={setViewImageModal}
                    />
                    </Grid>
                  )
                })}
              </GridContainer>
            </GridItem>
          )}

          {(status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie) ? (
            <GridContainer style={{ flexDirection: "row" }}>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: "end" }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                  
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress || disabledNext}
                  onClick={(event) => {tableData.length > 0 ? handleCloseModal() : handleDocumentSubmit(event)}}
                >
                  {tableData.length > 0 ? "Close" : "Submit"}
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} style={{ textAlign: "end" }}>
                <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                >
                  Back
                </Button>
                {!submitted && <Button
                  size="small"
                  className={classes.nextButton}
                  onClick={() => status === loanApplicationStatus?.submitted ? handleClose() : handlenext()}
                >
                  {status === loanApplicationStatus?.submitted ? "Close" : "Next"}
                </Button>}
              </GridItem>
            </GridContainer>
          )}
        </GridItem>
        {showDeviationTable && deviationTableData.length > 0 && (
            <GridContainer>
                <SubHeader
             label="Deviation History"
           />
              <TableContainer>
                <Table columns={deviationTableColumns} rows={deviationTableData} styles="style"/>
              </TableContainer>
            </GridContainer>
          )}
        {showTable && tableData.length > 0 && (
            <GridContainer>
                <SubHeader
             label="Approval History"
           />
              <TableContainer>
                <Table columns={tableColumns} rows={tableData} styles="style"/>
              </TableContainer>
            </GridContainer>
          )}
       
   {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {confirmationModal && (
          <ConfirmationModal
            confirmationModal={confirmationModal}
            confirmationModalHeader={confirmationModalHeader}
            confirmationModalMsg={confirmationModalMsg}
            handleNegativeButton={handleNegativeResponse}
            handlePositiveButton={handlePositiveResponse}
            classes={classes}
          />
        )}
        {viewImageModal && (
            <ViewImageModal
              showModal={viewImageModal}
              closeModal={() => setViewImageModal(false)}
               imageUrl={imageUrl}
           />
         )}
      </GridContainer>
    </div>
  );
};

DocumentNew.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default DocumentNew;